module.exports = __webpack_public_path__ + "static/media/Finwhale_warranty.c47efbd6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/static/docs/Finwhale_warranty.pdf
// module id = 835
// module chunks = 0